/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject } from '@angular/core';
import { ComponentCanDeactivate } from './component-can-deactivate';
import { TranslateService } from '@ngx-translate/core';
import { CanDeactivateFn } from '@angular/router';

export const formCanDeactivateGuard: CanDeactivateFn<ComponentCanDeactivate> = (
  component
) => {
  const translate = inject(TranslateService);
  let deactivateMessage: string | undefined = undefined;

  translate.get('shared-providers.deactivate-message').subscribe((res) => {
    deactivateMessage = res;
  });

  if (!component.canDeactivate()) {
    return confirm(deactivateMessage);
  }
  return true;
};
